<template>
  <div class="ui-pop" v-show="show">
    <div class="ui-mask"></div>
    <div class="ui-modal large scroll">
      <p class="modal-title">{{$t('PRIVACY_POLICY')}}</p>
      <a class="modal-close" @click="closePop"><i class="el-icon-close"></i></a>
      <div class="content terms">
        <p>Last updated: January 2021</p>
        <p>
          Newton Academic Tuition Co. Ltd (hereinafter referred to as "Newton")
          maintains a strict policy of client and tutor confidentiality, and we
          are committed to protecting and safeguarding your personal data. As
          part of this commitment, this policy aligns with the Data Protection
          Act 2018, and the General Data Protection Regulation (GDPR) ("Data
          Protection Laws"). This policy relates to all personal data that you
          provide to Newton and all personal data that Newton holds in relation
          to your use of our app and website. It supplements and is in addition
          to our Terms and Conditions and should be read in conjunction with
          them.
        </p>
        <p>What do we collect?</p>
        <p>
          In line with applicable Data Protection Laws, we are only able to
          process personal data where we have a valid reason to do so, including
          where you have provided your consent for us to do so, or where we are
          required to do so either to fulfil our contractual obligations to you,
          or to comply with our legal obligations.
        </p>
        <p>
          Registration and student details (for Clients): This includes details
          such as your name, email address, telephone number, your school year
          and your educational background.
        </p>
        <p>
          Registration and tutor details (for Tutors): This includes details
          such as your name, telephone number, email address, details of
          relevant teaching / tutoring experience, qualifications check (such as
          degree certificates) and identity check (such as your passport
          information page). We may also store your bank details for the purpose
          of making payments to you for work done through Newton.
        </p>
        <p>
          Usage data: we may also collect data regarding your use of our
          website, including geographical location, browser type and version,
          operating system, referral source, length of visit, page views and
          website navigation paths, as well as information about the timing,
          frequency and pattern of your use. This data is obtained through
          Google Analytics and will be aggregated and anonymised in such a way
          that it contains no information pertaining to any identifiable
          individual at all – as such it is not actually personal data but we
          address it in this Privacy Policy for completeness. We process usage
          data for the purpose of improving our website.
        </p>
        <p>What do we do with your information?</p>
        <p>
          We will use your personal data to fulfil tutoring requests, meet our
          contractual and legal obligations, ensure accurate and comprehensive
          record-keeping, send marketing communications and deliver a high
          quality service to both clients and tutors.
        </p>
        <p>Sharing information with third parties</p>
        <p>
          From time to time, we may also share personal data, with your consent,
          with third parties, such as schools. Other than sharing information as
          outlined above, we will keep your personal information confidential
          within our group of companies and not pass it on to any 3rd parties,
          unless we are required to do so by law.
        </p>
        <p>
          Tutors: The information that you provide to Newton forms the basis of
          a Tutor profile. This includes the following information: a
          photograph, the subjects that you teach, your teaching experience,
          personal biography, your personal teaching approach, and testimonials.
          Your profile will be published on our app and website in the internal
          Tutor profile list, viewable only by clients/students whose accounts
          have been approved by us. There is also an external Tutor profile
          list; your profile will only appear on this list if we have obtained
          your prior consent to do so. This external list is available on our
          app and website for the public to view, including clients/students
          whose accounts have not yet been approved.
        </p>
        <p>
          Newton may share your profile with prospective clients. Other than
          sharing information with our clients on the basis outlined above, we
          will keep your personal information confidential within our company
          and not pass it on to any 3rd parties, unless we are required to do so
          by law.
        </p>
        <p>
          Third party software providers: We use third party software as part of
          our services, such as online video conferencing and whiteboard
          services. These third party providers are subject to an equivalent
          degree of confidentiality and data security as we maintain at Newton,
          and any personal data that may be processed by or through such third
          party providers is only as is reasonably necessary in accordance with
          this Policy.
        </p>
        <p>How do we keep your information safe?</p>
        <p>
          We take reasonable steps to ensure that your information is kept safe
          and will endeavour to protect it from unauthorised access, using
          password-protected software systems, locked cabinets for hard copy
          documents, and other appropriate technical, organisational and
          security measures. Your information will be held securely within the
          Newton database, for the purposes stated above, for a maximum of 1
          year after you have cancelled your account with Newton. You have the
          right to request to see what data Newton holds by emailing
          enquiry@newtontutor.hk, and you will receive a response within 30
          calendar days.
        </p>
        <p>
          In addition, we limit access to your personal data to those staff who
          have a business need to know. They will only process your personal
          data on our instructions and they are subject to a duty of
          confidentiality.
        </p>
        <p>
          A Tutor can view a student's personal profile information only after
          the student has booked lessons with the Tutor.
        </p>
        <p>Cookies</p>
        <p>
          A cookie is a piece of information that web servers send to your
          browser file when you access a website, then when you come back to a
          website again, that website will detect whether you have cookies on
          your browser file.
        </p>
        <p>
          We occasionally issue session cookies when strictly necessary for the
          operation of the website. These cookies do not hold any personal
          information.
        </p>
        <p>
          We use cookies to identify which pages on our website are being used.
          This helps us analyse data about web page traffic and improve our
          website in order to tailor it to user needs. We only use this
          information for statistical analysis purposes and then the data is
          removed from the system.
        </p>
        <p>
          Overall, cookies help us provide you with a better service, by
          enabling us to monitor which pages you find useful and which ones you
          do not. A cookie in no way gives us access to your computer or any
          information about you, other than the data you choose to share with
          us.
        </p>
        <p>
          Most web browsers automatically accept cookies, but you can usually
          modify your browser setting to decline cookies if you prefer. This may
          prevent you from taking full advantage of our website.
        </p>
        <p>
          As regards your rights in relation to any personal data that we are in
          possession of or processing, you, the data subject, have the following
          rights:
        </p>
        <p>
          Right of access - you have the right to request a copy of the
          information that we hold about you. Right of rectification - you have
          the right to correct data that we hold about you that is inaccurate or
          incomplete.
        </p>
        <p>
          Right to be forgotten - in certain circumstances, you can ask for the
          data that we hold about you to be erased from our records.
        </p>
        <p>
          Right to object - you have the right to object to certain types of
          processing, such as direct marketing.
        </p>
        <p>
          Please contact enquiry@newtontutor.hk if you would like to exercise
          any of these rights at any time.
        </p>
        <p>Third party sites</p>
        <p>
          We may link to a number of other websites on our site. We are not
          responsible in any way for the privacy policies of these sites, nor
          for the way in which they may use the information that they collect
          about you.
        </p>
        <p>Changes to this Policy</p>
        <p>
          We keep this Policy under regular review, so you are advised to review
          it from time to time so that you are aware of any changes. We may also
          notify you of any significant changes made as and when relevant. This
          Policy was last updated on the date set out above.
        </p>
        <p>Contact</p>
        <p>
          If you have any questions in relation to this Privacy Policy, please
          contact enquiry@newtontutor.hk
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['show'],
  methods: {
    closePop() {
      this.$parent.show1 = false
    },
  },
}
</script>
<style lang="scss" scoped>
.terms {
  padding: 50px;
  font-size: 14px;
  line-height: 1.5;
  p {
    margin-top: 20px;
  }
}
@media screen and (max-width: 768px) {
  .terms {
    padding: 20px;
  }
}
</style>